import { Controller } from "@hotwired/stimulus";

/**
 * Toggle classes on or off for one or more elements within the
 * container element.
 *
 * Example:
 *   <button
 *     type="button"
 *     data-controller="toggle-classes"
 *     data-action="toggle-classes#toggle"
 *   >
 *     <div
 *       class=""
 *       data-toggle-classes-target="item"
 *       data-toggle-classes="font-bold text-blue-600"
 *     >
 *       Toggle bold and blue
 *     </div>
 *     <div
 *       class="font-bold text-orange-600"
 *       data-toggle-classes-target="item"
 *       data-toggle-classes="font-bold text-orange-600"
 *     >
 *       Toggle orange and bold
 *     </div>
 *   </button>
 */
export default class extends Controller {
  static targets = ["item"];

  toggle() {
    /**
     * Loop over each item target, and if it has a [data-toggle-classes]
     * attribute, toggle those classes.
     */
    this.itemTargets.forEach((target) => {
      if (target.hasAttribute("data-toggle-classes")) {
        const classes = target.getAttribute("data-toggle-classes").split(" ");
        classes.forEach((classname) => {
          target.classList.toggle(classname);
        });
      }
    });
  }
}
